import React, {ReactElement} from 'react';

import {INavigation} from './types';
import NavigationMobile from './NavigationMobile/NavigationMobile';
import NavigationDesktop from './NavigationDesktop/NavigationDesktop';

function Navigation({
  ctaButton,
  loginMenuText,
  alternativeJourneyLink,
  sections,
  hideTideBranding,
  isSkipQuoteFormAndRedirectToTide,
}: INavigation): ReactElement {
  return (
    <>
      <NavigationDesktop
        ctaButton={ctaButton}
        loginMenuText={loginMenuText}
        alternativeJourneyLink={alternativeJourneyLink}
        sections={sections}
        hideTideBranding={hideTideBranding}
        isSkipQuoteFormAndRedirectToTide={isSkipQuoteFormAndRedirectToTide}
      />
      <NavigationMobile
        ctaButton={ctaButton}
        loginMenuText={loginMenuText}
        alternativeJourneyLink={alternativeJourneyLink}
        sections={sections}
        hideTideBranding={hideTideBranding}
        isSkipQuoteFormAndRedirectToTide={isSkipQuoteFormAndRedirectToTide}
      />
    </>
  );
}

export default Navigation;
